// Fix to make sure number doesn't return as NaNpx
function sanitizeNumber(value) {
  if (value === undefined || value === null || value === '') return undefined;

  const num = Number(value);
  return Number.isNaN(num) ? undefined : num;
}

export default sanitizeNumber;
